"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.swaggerPublicDocument = exports.swaggerDocument = exports.makeSwaggerDocument = void 0;
var tslib_1 = require("tslib");
var packageManifest = tslib_1.__importStar(require("../../package.json"));
var collection_get_schema_1 = require("./endpoints/public/collection/collection.get.schema");
var collection_list_get_schema_1 = require("./endpoints/public/collection/collection.list.get.schema");
var department_get_schema_1 = require("./endpoints/public/department/department.get.schema");
var department_list_get_schema_1 = require("./endpoints/public/department/department.list.get.schema");
var export_get_schema_1 = require("./endpoints/public/export/export.get.schema");
var form_get_schema_1 = require("./endpoints/public/form/form.get.schema");
var form_list_get_schema_1 = require("./endpoints/public/form/form.list.get.schema");
var job_get_schema_1 = require("./endpoints/public/job/job.get.schema");
var job_list_get_schema_1 = require("./endpoints/public/job/job.list.get.schema");
// import { definition as loginDefinition } from './endpoints/public/login.get.schema';
var port = process.env.PORT || '1337';
var PUBLIC = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, department_list_get_schema_1.definition), department_get_schema_1.definition), form_list_get_schema_1.definition), form_get_schema_1.definition), job_get_schema_1.definition), job_list_get_schema_1.definition), collection_list_get_schema_1.definition), collection_get_schema_1.definition), export_get_schema_1.definition);
var INTERNAL = {};
var makeSwaggerDocument = function (_a) {
    var _b = _a === void 0 ? {} : _a, publicOnly = _b.publicOnly;
    return ({
        openapi: '3.0.0',
        components: {
            securitySchemes: {
                BearerAuth: {
                    type: 'http',
                    scheme: 'bearer',
                    name: 'Authorization',
                    bearerFormat: 'JWT'
                }
            },
            parameters: {
                ikeRequester: {
                    name: 'X-Ike-Requester',
                    in: 'header',
                    description: 'A name to indicate who / where the request is originating from',
                    required: true,
                    schema: {
                        type: 'string',
                        default: 'Swagger',
                        enum: ['Swagger']
                    }
                },
                ikeDepartmentId: {
                    name: 'X-Ike-Department-Id',
                    in: 'header',
                    description: 'The ID of the department you wish to query from',
                    required: true,
                    schema: {
                        type: 'string'
                    }
                },
                departmentIdPath: {
                    name: 'department_id',
                    in: 'path',
                    description: 'The ID of the department you wish to query for',
                    required: true,
                    schema: {
                        type: 'string'
                    }
                },
                formIdPath: {
                    name: 'form_id',
                    in: 'path',
                    description: 'The ID of the form you wish to query for',
                    required: true,
                    schema: {
                        type: 'string'
                    }
                },
                jobIdPath: {
                    name: 'job_id',
                    in: 'path',
                    description: 'The ID of the job you wish to query for',
                    required: true,
                    schema: {
                        type: 'string'
                    }
                },
                collectionIdPath: {
                    name: 'collection_id',
                    in: 'path',
                    description: 'The ID of the collection you wish to query for',
                    required: true,
                    schema: {
                        type: 'string'
                    }
                }
            }
        },
        security: [
            {
                BearerAuth: []
            }
        ],
        info: {
            title: 'Ike Office API',
            version: packageManifest.version,
            description: 'The private and public API endpoints for the Ike Office API'
        },
        servers: [
            {
                url: 'https://automation.office.ikegps.net',
                description: 'Automation Environment'
            },
            {
                url: "http://localhost:".concat(port, "/v1"),
                description: 'Local server'
            },
            {
                url: 'https://test.office.ikegps.net',
                description: 'Test Environment'
            },
            {
                url: 'https://test2.office.ikegps.net',
                description: 'Test 2 Environment'
            },
            {
                url: 'https://staging.office.ikegps.net',
                description: 'Staging Environment'
            },
            {
                url: 'https://office.ikegps.com',
                description: 'Production Environment'
            }
        ],
        paths: tslib_1.__assign(tslib_1.__assign({}, publicOnly
            ? undefined
            : INTERNAL), PUBLIC)
    });
};
exports.makeSwaggerDocument = makeSwaggerDocument;
exports.swaggerDocument = (0, exports.makeSwaggerDocument)();
exports.swaggerPublicDocument = (0, exports.makeSwaggerDocument)({
    publicOnly: true
});
//# sourceMappingURL=swagger.document.factory.js.map